module.exports = __webpack_public_path__ + "images/corners/Durango.2798feee889c27a9ba55d8fcd36bf3c4.jpg";